import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/** Talep türü ekle/düzenle form şeması (020): nameTr zorunlu; nameEn opsiyonel. Sıra formda yok (tablodan). */
export const ticketTypeFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type TicketTypeFormValues = z.infer<typeof ticketTypeFormSchema>
